import React from "react";
import Select from "react-select";
import { Button } from "aible";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { LineInput } from "components/Inputs/LineInput";

import Logo from "images/logo.png";

import styles from "./style.module.css";

export default class ResetSuccess extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      counter: 5
    };

    this.state.timer = setTimeout(() => this.handleCounter(), 1000);
  }

  handleCounter() {
    const { history } = this.props;

    const { counter } = this.state;

    const retCounter = counter - 1;

    if (counter <= 0) {
      return history.push("/login");
    }

    const retTimer = setTimeout(() => this.handleCounter(), 1000);

    return this.setState({ counter: retCounter, timer: retTimer });
  }

  render() {
    const {
      isLoading,
      error,
      tenants,
      selectTenant,
      resetTenants,
      resetMessage,
      handlePasswordReset,
      updateResetMessage,
      history
    } = this.props;

    const hasReset = resetMessage !== undefined;

    // const isLoading = true;

    return (
      <div className={styles.body}>
        <div className={styles.loginBox} style={hasReset ? { paddingBottom: "0px" } : undefined}>
          <div className={styles.loginHeader}>
            <div className={styles.name}>
              <img className={styles.logoImage} src={Logo} />
            </div>
          </div>
          <div className={styles.loginContent}>
            <div className={styles.header}>{"Password Successfully Reset"}</div>
            <div className={styles.resetMessage}>
              {this.state.counter > 0
                ? `You will be redirected to the Aible login screen in ${this.state.counter} second${this.state.counter !== 1 ? "s" : ""}`
                : `Redirecting...`}
            </div>
            <div className={styles.newUser}>
              <div className={styles.reset}>
                <a onClick={() => history.push("/login")}>{"Back to Login"}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
